



































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Spinner from "@/components/Spinner.vue";
import TOMFragebogenBaustein from "./TOMFragebogen-Baustein.vue";
import TOMFragebogenButtons from "./TOMFragebogen-Buttons.vue";
import TOMFragebogen from "../TOMFragebogen";
import TOMFragebogenNummerierung from "./TOMFragebogen-Nummerierung.vue";
import TOMFragebogenText from "./TOMFragebogen-Text.vue";

@Component({
  components: {
    Spinner,
    TOMFragebogenButtons,
    TOMFragebogenNummerierung,
    TOMFragebogenText,
  },
})
export default class TOMFragebogenMassnahme extends TOMFragebogenBaustein {
  get istListenElement() {
    const elternteil =
      this.baustein[TOMFragebogen.Baustein.Symbols.elternteilElement];
    return (
      elternteil !== null &&
      elternteil !== undefined &&
      elternteil.Art === TOMFragebogen.Baustein.Art.Ueberschrift2Ordnung
    );
  }
}
